import React from "react";
import * as ReactBootstrap from "react-bootstrap";
import CurrencyFormat from "react-currency-format";

const StatFormatter = (data) => {
  const classList = data < 0 ? "Negative" : "Positive";

  return (
    <div className={`Status ${classList}`}>
      <CurrencyFormat
        value={data}
        displayType={"text"}
        thousandSeparator={true}
        prefix={"$"}
      />
    </div>
  );
};

const PositionResultTable = ({ data }) => {
  const renderPositionResult = (lot, index) => {
    return (
      <tr key={index}>
        <td>{lot}</td>
        <td>{data[lot].number_of_trade}</td>
        <td>{StatFormatter(Number(data[lot].results).toFixed(2))}</td>
      </tr>
    );
  };

  return (
    <div className="CommonTable PositionResultTable">
      <ReactBootstrap.Table>
        <thead>
          <tr>
            <th>Order Size</th>
            <th>No. trades</th>
            <th>Results</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            Object.keys(data).length &&
            Object.keys(data).map(renderPositionResult)}
        </tbody>
      </ReactBootstrap.Table>
    </div>
  );
};

export default PositionResultTable;
